var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJourney1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .aj1,.cj1,.dj1{fill:none;}.bj1,.ej1{fill:#fff;}.bj1,.cj1,.dj1{stroke:#707070;stroke-width:4px;}.dj1{stroke-miterlimit:10;}.fj1{fill:#b30200;}.gj1{stroke:none;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aj1",
    width: 96,
    height: 96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-375 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bj1",
    transform: "translate(426 234)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "gj1",
    width: 37,
    height: 39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj1",
    x: -2,
    y: -2,
    width: 41,
    height: 43
  })), /*#__PURE__*/React.createElement("path", {
    className: "cj1",
    d: "M-6096.492-19750.309v-10h26v10",
    transform: "translate(6527.992 20000)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cj1",
    d: "M-6096.493-19750.309v-10h26v10",
    transform: "translate(-5638.993 -19492.617) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "dj1",
    x2: 4,
    transform: "translate(429.5 253.25)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "dj1",
    x2: 4,
    transform: "translate(455.5 253.25)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-219.434 -0.281)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ej1",
    width: 14,
    height: 30,
    transform: "translate(227.434 56.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fj1",
    d: "M241.434,86.511h-14v-30h14Zm-10-4h6v-22h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ej1",
    d: "M245.7,84.312h24.613l10.212-18.977V57.12h-21.95s4.7-13.974,2.587-16.816c-.187-.369-15.464,15.711-15.464,15.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fj1",
    d: "M270.312,86.312H245.7a2,2,0,0,1-2-2l0-28.3a2,2,0,0,1,.55-1.378C259.958,38.1,260.1,38.12,261.442,38.319a2.025,2.025,0,0,1,1.324.791h0c2.04,2.744.28,10.367-1.448,16.01h19.205a2,2,0,0,1,2,2v8.215a2.01,2.01,0,0,1-.238.948L272.073,85.259A2,2,0,0,1,270.312,86.312Zm-22.613-4h21.418l9.406-17.481V59.12H258.574a2,2,0,0,1-1.9-2.637,66.474,66.474,0,0,0,2.933-12c-2.859,2.876-7.547,7.738-11.915,12.329Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney1);
export default __webpack_public_path__ + "static/media/journey1.d49e43e36aa53e698ecee688fb10ac81.svg";
export { ForwardRef as ReactComponent };